module.exports = __webpack_public_path__ + "static/img/jinbi.b13b88e7.png";